<div class="pagination">
  <div class="table-paging justify-content-between">
    <div class="left-col">
      <button
        class="btn btn-default btn-circle"
        (click)="setPage(1)"
        [disabled]="pageConfig.currentPage === 1"
      >
        <i nz-icon nzType="double-left" nzTheme="outline"></i>
      </button>
      <button
        class="btn btn-default btn-circle"
        (click)="setPage(pageConfig.currentPage - 1)"
        [disabled]="pageConfig.currentPage === 1"
      >
        <i nz-icon nzType="left" nzTheme="outline"></i>
      </button>
      <input
        type="number"
        value="1"
        min="1"
        class="input-paging"
        (keyup.enter)="changedPage($event)"
        [value]="pageConfig.currentPage"
      />
      <button
        class="btn btn-default btn-circle"
        (click)="setPage(pageConfig.currentPage + 1)"
        [disabled]="
          pageConfig.currentPage === pageConfig.totalPage ||
          (pageConfig.data && pageConfig.data.length < 1)
        "
      >
        <i nz-icon nzType="right" nzTheme="outline"></i>
      </button>
      <button
        class="btn btn-default btn-circle"
        (click)="setPage(pageConfig.totalPage)"
        [disabled]="
          pageConfig.currentPage === pageConfig.totalPage ||
          (pageConfig.data && pageConfig.data.length < 1)
        "
      >
        <i nz-icon nzType="double-right" nzTheme="outline"></i>
      </button>
    </div>

    <div class="right-col">
      <div class="table-in">
        <div>
          <span>
            {{ pageConfig?.currentPage }}/{{ pageConfig?.totalPage }}</span
          >
          -
          <span>Total {{ pageConfig?.totalItem }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
